import { useLingui } from '@lingui/react/macro'
import { createFileRoute } from '@tanstack/react-router'
import { SelfExclusion } from '@/features/self-exclusion/self-exclusion'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'
import { TakeABreak } from '@/features/take-a-break/take-a-break'
import { useGetTakeABreakStateQuery } from '@/features/take-a-break/use-get-take-a-break-state-query'
import { CircleLoadingAnimation } from '@vgw/multibrand-fe-circle-loading-animation'
import { useQuery } from '@tanstack/react-query'
import { getSelfExclusionPlayerOptions } from '@/apis/pam-rsg-api'
import { AccessControlsInfo } from '@/features/access-controls/access-controls-info'
import { isActiveTakeABreak } from '@/features/access-controls/is-active-take-a-break'

export const Route = createFileRoute('/_app/your-play/access-controls/all')({
  component: AccessControls,
})

function AccessControls() {
  const { t } = useLingui()
  const { isPending: takeABreakIsPending, data: takeABreak } =
    useGetTakeABreakStateQuery()
  const { isPending: selfExclusionIsPending, data: selfExclusion } = useQuery({
    ...getSelfExclusionPlayerOptions(),
    retry: false, // when no self exclusion we get 404, so need to suppress retries. Also there is no error response in this API so cannot even filter by error.status == 404 here, so suppressing all errors
  })

  const takeABreakActive = takeABreak?.defined && isActiveTakeABreak(takeABreak)

  return (
    <TertiaryPageLayout
      headerText={t`Access Controls`}
      infoDrawerContent={<AccessControlsInfo />}
    >
      {takeABreakIsPending || selfExclusionIsPending ? (
        <div className="flex w-full justify-center">
          <CircleLoadingAnimation />
        </div>
      ) : (
        <>
          {takeABreakActive && !selfExclusion ? (
            <>
              <TakeABreak takeABreak={takeABreak} />
              <div className="mt-4">
                <SelfExclusion selfExclusion={selfExclusion} />
              </div>
            </>
          ) : !takeABreakActive && !selfExclusion ? (
            <>
              <SelfExclusion selfExclusion={selfExclusion} />
              <div className="mt-4">
                <TakeABreak takeABreak={takeABreak} />
              </div>
            </>
          ) : (
            <>
              <SelfExclusion selfExclusion={selfExclusion} />
            </>
          )}
        </>
      )}
    </TertiaryPageLayout>
  )
}
